<template>
  <div class="call-center-queues-setting">
    <v-card class="call-center-settings-card">
      <v-card-title class="call-center-settings-title pb-0">
        الاكواد الخاصه بالمكالمات الوارده والصادره من الكول سنتر
      </v-card-title>
      <v-card-subtitle class="call-center-settings-subtitle pb-4" >
        إدارة الاكواد الخاصه بالمكالمات الوارده والصادره من الكول سنتر
      </v-card-subtitle>

      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            <v-card outlined class="queue-section-card queue-section-card--incoming">
              <v-card-title class="queue-section-title">
                <v-icon small class="queue-section-icon queue-section-icon--incoming">mdi-phone-incoming</v-icon>
                الاكواد الخاصه بالمكالمات الوارده
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="headers"
                  :items="incomingQueues"
                  :loading="loading"
                  hide-default-footer
                  class="queue-data-table elevation-0"
                  mobile-breakpoint="0"
                >
                  <template v-slot:[`item.is_active`]="{ item }">
                    <v-chip
                      small
                      class="status-chip"
                      :class="item.is_active ? 'status-chip--active' : 'status-chip--inactive'"
                    >
                      {{ item.is_active ? 'نشط' : 'غير نشط' }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn icon small class="action-btn action-btn--edit" @click="openEditDialog(item)">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon small class="action-btn action-btn--delete" @click="confirmDelete(item)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
                <v-btn text class="add-queue-btn add-queue-btn--incoming mt-2" @click="openAddDialog('incoming')">
                  <v-icon left small>mdi-plus</v-icon>
                  إضافة كود وارد
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card outlined class="queue-section-card queue-section-card--outgoing">
              <v-card-title class="queue-section-title">
                <v-icon small class="queue-section-icon queue-section-icon--outgoing">mdi-phone-outgoing</v-icon>
                الاكواد الخاصه بالمكالمات الصادره
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="headers"
                  :items="outgoingQueues"
                  :loading="loading"
                  hide-default-footer
                  class="queue-data-table elevation-0"
                  mobile-breakpoint="0"
                >
                  <template v-slot:[`item.is_active`]="{ item }">
                    <v-chip
                      small
                      class="status-chip"
                      :class="item.is_active ? 'status-chip--active' : 'status-chip--inactive'"
                    >
                      {{ item.is_active ? 'نشط' : 'غير نشط' }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn icon small class="action-btn action-btn--edit" @click="openEditDialog(item)">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon small class="action-btn action-btn--delete" @click="confirmDelete(item)">
                      <v-icon small>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
                <v-btn text class="add-queue-btn add-queue-btn--outgoing mt-2" @click="openAddDialog('outgoing')">
                  <v-icon left small>mdi-plus</v-icon>
                  إضافة كود صادر
                </v-btn>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-dialog v-model="dialog" max-width="520px" persistent content-class="call-center-queue-dialog">
      <v-card class="call-center-dialog-card">
        <v-card-title class="call-center-dialog-title">
          {{ editMode ? 'تعديل' : 'إضافة' }} كود
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="form.name"
              label="اسم الكود (queue_name)"
              outlined
              dense
              :rules="[rules.required]"
              required
            />
            <v-select
              v-model="form.type"
              :items="typeOptions"
              item-text="label"
              item-value="value"
              label="نوع الكود"
              outlined
              dense
              :rules="[rules.required]"
              required
            />
            <v-text-field
              v-model.number="form.sort_order"
              label="الترتيب"
              type="number"
              min="0"
              outlined
              dense
            />
            <v-switch v-model="form.is_active" label="نشط" color="primary" inset />
          </v-form>
        </v-card-text>
        <v-card-actions class="call-center-dialog-actions">
          <v-spacer />
          <v-btn text class="dialog-cancel-btn" @click="closeDialog">إلغاء</v-btn>
          <v-btn color="primary" class="dialog-save-btn" :loading="saving" @click="saveQueue">حفظ</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="420px" persistent content-class="call-center-queue-dialog">
      <v-card class="call-center-dialog-card">
        <v-card-title class="call-center-dialog-title">تأكيد الحذف</v-card-title>
        <v-card-text class="call-center-dialog-text">
          هل أنت متأكد من حذف الكود "{{ queueToDelete?.name }}"؟
        </v-card-text>
        <v-card-actions class="call-center-dialog-actions">
          <v-spacer />
          <v-btn text class="dialog-cancel-btn" @click="deleteDialog = false">إلغاء</v-btn>
          <v-btn color="error" :loading="deleting" @click="deleteQueue">حذف</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Axios from "axios";
import { axiosInstance } from "@/axios/config";

export default {
  name: "CallCenterQueuesSetting",
  data() {
    return {
      loading: false,
      saving: false,
      deleting: false,
      incomingQueues: [],
      outgoingQueues: [],
      dialog: false,
      deleteDialog: false,
      editMode: false,
      valid: false,
      queueToDelete: null,
      form: {
        id: null,
        name: "",
        type: "incoming",
        sort_order: 0,
        is_active: true,
      },
      headers: [
        { text: "الاسم", value: "name" },
        { text: "الترتيب", value: "sort_order" },
        { text: "الحالة", value: "is_active" },
        { text: "إجراءات", value: "actions", sortable: false, align: "center" },
      ],
      typeOptions: [
        { label: "واردة", value: "incoming" },
        { label: "صادرة", value: "outgoing" },
      ],
      rules: {
        required: (v) => !!v || "هذا الحقل مطلوب",
      },
    };
  },
  created() {
    this.fetchQueues();
  },
  methods: {
    fetchQueues() {
      this.loading = true;
      Axios.get(`${this.$store.state.url}/employee/admin/call-center-queues`, {
        headers: this.request_headers(),
      })
        .then((res) => {
          this.incomingQueues = res.data.payload.incoming || [];
          this.outgoingQueues = res.data.payload.outgoing || [];
        })
        .catch((err) => {
          this.showPopup("error", err.response?.data?.message || "حدث خطأ أثناء تحميل الاكواد");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openAddDialog(type) {
      this.editMode = false;
      this.form = {
        id: null,
        name: "",
        type,
        sort_order: 0,
        is_active: true,
      };
      this.dialog = true;
    },
    openEditDialog(item) {
      this.editMode = true;
      this.form = {
        id: item.id,
        name: item.name,
        type: item.type,
        sort_order: item.sort_order || 0,
        is_active: !!item.is_active,
      };
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    saveQueue() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.saving = true;
      const payload = {
        name: this.form.name,
        type: this.form.type,
        sort_order: this.form.sort_order,
        is_active: this.form.is_active ? 1 : 0,
      };

      const request = this.editMode
        ? axiosInstance.post(`/employee/admin/call-center-queues/${this.form.id}/update`, payload)
        : axiosInstance.post(`/employee/admin/call-center-queues/store`, payload);

      request
        .then((res) => {
          this.showPopup("success", res.data.message);
          this.closeDialog();
          this.fetchQueues();
        })
        .catch((err) => {
          this.showPopup("error", err.response?.data?.message || "حدث خطأ أثناء الحفظ");
        })
        .finally(() => {
          this.saving = false;
        });
    },
    confirmDelete(item) {
      this.queueToDelete = item;
      this.deleteDialog = true;
    },
    deleteQueue() {
      if (!this.queueToDelete) {
        return;
      }

      this.deleting = true;
      axiosInstance
        .get(`/employee/admin/call-center-queues/${this.queueToDelete.id}/delete`)
        .then((res) => {
          this.showPopup("success", res.data.message);
          this.deleteDialog = false;
          this.queueToDelete = null;
          this.fetchQueues();
        })
        .catch((err) => {
          this.showPopup("error", err.response?.data?.message || "حدث خطأ أثناء الحذف");
        })
        .finally(() => {
          this.deleting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.call-center-settings-card {
  padding: 10px 12px 8px;
  border: 1px solid rgba(63, 14, 64, 0.12);
  border-radius: 12px;
  background: #ffffff;
}

.call-center-settings-title {
  color: #3f0e40;
  font-weight: 700;
  font-size: 1.15rem;
}

.call-center-settings-subtitle {
  color: #666;
  padding-top: 30px !important;
  padding-inline: 16px !important;
}

.queue-section-card {
  border-radius: 12px;
  overflow: hidden;
  background: #fafafa;
}

.queue-section-card--incoming {
  border-color: rgba(21, 101, 192, 0.22) !important;
  background: rgba(21, 101, 192, 0.04);
}

.queue-section-card--outgoing {
  border-color: rgba(126, 18, 128, 0.22) !important;
  background: rgba(126, 18, 128, 0.04);
}

.queue-section-title {
  font-size: 1rem !important;
  font-weight: 700;
  color: #451646;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid rgba(69, 22, 70, 0.12);
}

.queue-section-icon--incoming {
  color: #1565c0 !important;
}

.queue-section-icon--outgoing {
  color: #7e1280 !important;
}

.queue-data-table ::v-deep thead th {
  color: #451646 !important;
  font-weight: 700 !important;
  background: rgba(255, 255, 255, 0.72);
}

.queue-data-table ::v-deep tbody td {
  color: #333;
  border-bottom-color: rgba(0, 0, 0, 0.06) !important;
}

.status-chip {
  font-weight: 600;
}

.status-chip--active {
  background: rgba(46, 125, 50, 0.14) !important;
  color: #2e7d32 !important;
}

.status-chip--inactive {
  background: rgba(198, 40, 40, 0.12) !important;
  color: #c62828 !important;
}

.action-btn--edit {
  color: #1565c0 !important;
}

.action-btn--delete {
  color: #c62828 !important;
}

.add-queue-btn {
  font-weight: 600;
}

.add-queue-btn ::v-deep .v-btn__content {
  color: inherit !important;
}

.add-queue-btn--incoming,
.add-queue-btn--incoming ::v-deep .v-btn__content,
.add-queue-btn--incoming ::v-deep .v-icon {
  color: #1565c0 !important;
}

.add-queue-btn--outgoing,
.add-queue-btn--outgoing ::v-deep .v-btn__content,
.add-queue-btn--outgoing ::v-deep .v-icon {
  color: #7e1280 !important;
}

.call-center-dialog-title {
  color: #3f0e40;
  font-weight: 700;
}

.call-center-dialog-text {
  color: #444;
}

.dialog-cancel-btn {
  color: #666 !important;
}

.dialog-save-btn {
  min-width: 96px;
  font-weight: 600;
}

/* Dark mode */
.dark .call-center-settings-card {
  background: #1e1e1e;
  border-color: rgba(255, 255, 255, 0.12);
}

.dark .call-center-settings-title {
  color: rgba(255, 255, 255, 0.92);
}

.dark .call-center-settings-subtitle {
  color: rgba(255, 255, 255, 0.68);
}

.dark .queue-section-card--incoming {
  background: rgba(66, 165, 245, 0.1);
  border-color: rgba(66, 165, 245, 0.28) !important;
}

.dark .queue-section-card--outgoing {
  background: rgba(171, 71, 188, 0.1);
  border-color: rgba(171, 71, 188, 0.28) !important;
}

.dark .queue-section-title {
  color: rgba(255, 255, 255, 0.92);
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

.dark .queue-section-icon--incoming {
  color: #64b5f6 !important;
}

.dark .queue-section-icon--outgoing {
  color: #ce93d8 !important;
}

.dark .queue-data-table ::v-deep thead th {
  color: rgba(255, 255, 255, 0.88) !important;
  background: rgba(255, 255, 255, 0.06);
}

.dark .queue-data-table ::v-deep tbody td {
  color: rgba(255, 255, 255, 0.86);
  border-bottom-color: rgba(255, 255, 255, 0.08) !important;
}

.dark .queue-data-table ::v-deep .v-data-table {
  background: transparent !important;
}

.dark .status-chip--active {
  background: rgba(102, 187, 106, 0.2) !important;
  color: #a5d6a7 !important;
}

.dark .status-chip--inactive {
  background: rgba(239, 83, 80, 0.18) !important;
  color: #ef9a9a !important;
}

.dark .action-btn--edit {
  color: #90caf9 !important;
}

.dark .action-btn--delete {
  color: #ef9a9a !important;
}


.dark .call-center-dialog-card {
  background: #1e1e1e;
}

.dark .call-center-dialog-title {
  color: rgba(255, 255, 255, 0.92);
}

.dark .call-center-dialog-text {
  color: rgba(255, 255, 255, 0.78);
}

.dark .dialog-cancel-btn {
  color: rgba(255, 255, 255, 0.72) !important;
}
</style>

<style lang="scss">
.call-center-queues-setting .add-queue-btn--incoming,
.call-center-queues-setting .add-queue-btn--incoming .v-btn__content,
.call-center-queues-setting .add-queue-btn--incoming .v-icon {
  color: #1565c0 !important;
}

.call-center-queues-setting .add-queue-btn--outgoing,
.call-center-queues-setting .add-queue-btn--outgoing .v-btn__content,
.call-center-queues-setting .add-queue-btn--outgoing .v-icon {
  color: #7e1280 !important;
}

.dark .call-center-queues-setting .add-queue-btn--incoming,
.dark .call-center-queues-setting .add-queue-btn--incoming .v-btn__content,
.dark .call-center-queues-setting .add-queue-btn--incoming .v-icon,
.v-application.dark .call-center-queues-setting .add-queue-btn--incoming,
.v-application.dark .call-center-queues-setting .add-queue-btn--incoming .v-btn__content,
.v-application.dark .call-center-queues-setting .add-queue-btn--incoming .v-icon {
  color: #90caf9 !important;
}

.dark .call-center-queues-setting .add-queue-btn--outgoing,
.dark .call-center-queues-setting .add-queue-btn--outgoing .v-btn__content,
.dark .call-center-queues-setting .add-queue-btn--outgoing .v-icon,
.v-application.dark .call-center-queues-setting .add-queue-btn--outgoing,
.v-application.dark .call-center-queues-setting .add-queue-btn--outgoing .v-btn__content,
.v-application.dark .call-center-queues-setting .add-queue-btn--outgoing .v-icon {
  color: #ce93d8 !important;
}

.theme--dark .call-center-queue-dialog .v-card,
.dark .call-center-queue-dialog .v-card {
  background: #1e1e1e;
}

.theme--dark .call-center-queue-dialog .v-label,
.dark .call-center-queue-dialog .v-label {
  color: rgba(255, 255, 255, 0.72);
}

.theme--dark .call-center-queue-dialog .v-input__slot,
.dark .call-center-queue-dialog .v-input__slot {
  border-color: rgba(255, 255, 255, 0.24) !important;
}
</style>
